import { useMutation, useQueryClient } from '@tanstack/react-query';

import { copyWorkspaceQuiz } from '../../../api/workspaces';
import { WorkspaceQuiz } from '../../../api/workspaces/quiz/types';
import { addWorkspaceQuiz } from './useCopyPersonalToWorkspace';
import { workspaceKeys } from './workspaceQueryKeyFactory';

export function useCopyWorkspaceQuiz() {
  const queryClient = useQueryClient();
  return useMutation({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    mutationFn: copyWorkspaceQuiz,
    onSuccess: (data: WorkspaceQuiz, { workspaceId }) => {
      queryClient.setQueryData<WorkspaceQuiz[]>(
        workspaceKeys.quizzes({ workspaceId: workspaceId }),
        (state) => addWorkspaceQuiz(state, { ...data })
      );
    },
  });
}
